import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function FotoGaleryCard(props) {
    const { post, layout } = props;
    const path = process.env.REACT_APP_FILESPATH;
    const image = `${path}${post.media?.mediaEmri}${post.media?.mediaEx}`;
    const cardClasses = classNames(
        'galery-card',
        {
            'post-card--layout--grid': ['grid-nl', 'grid-nl-4', 'grid-lg'].includes(layout),
            'post-card--layout--list': ['list-nl', 'list-sm'].includes(layout),
            'post-card--size--nl': ['grid-nl', 'grid-nl-4', 'list-nl'].includes(layout),
            'post-card--size--lg': layout === 'grid-lg',
            'post-card--size--sm': layout === 'list-sm',
        },
    );
    return (
        <div className={cardClasses}>
            <div className="post-card__image galery-img">
                <Link
                    to={post.url}
                    name="link"
                    aria-label="link"
                    rel="link"
                >
                    <img src={post.media?.otherSource === null ? image : post.media?.otherSource} alt="" />
                </Link>
            </div>
            <div className="post-card__info galery-info">
                <div className="post-card__name">
                    <Link
                        to={post.url}
                        name="link"
                        aria-label="link"
                        rel="link"
                    >
                        {post.mediaGaleriaPershkrimi}
                    </Link>
                </div>
            </div>
        </div>
    );
}

FotoGaleryCard.propTypes = {
    layout: PropTypes.oneOf(['grid-nl', 'grid-nl-4', 'grid-lg', 'list-nl', 'list-sm']),
};

FotoGaleryCard.defaultProps = {
    layout: 'grid-nl-4',
};

export default FotoGaleryCard;
